import { TIER_BOSS_SIZE } from '../../constants';
import { GoblinKingSprite } from '../../assets/GoblinKingSprite';

/**
 * Tier Boss visual — directional goblin-king sprite with HP bar.
 * Not memo-ised: the enemy object is mutated in-place by the game loop so
 * React.memo would always see the same reference and skip updates.
 * Props: x, y, hp, maxHp, playerCx, playerCy
 */
export function TierBossEntity({ x, y, hp, maxHp, playerCx = 0, playerCy = 0 }) {
  const hpFrac = Math.max(0, hp / maxHp);
  const ecx    = x + TIER_BOSS_SIZE / 2;
  const ecy    = y + TIER_BOSS_SIZE / 2;
  const dx     = playerCx - ecx;
  const dy     = playerCy - ecy;

  return (
    <div
      className="tier-boss-entity"
      style={{ transform: `translate3d(${x}px,${y}px,0)`, width: TIER_BOSS_SIZE, height: TIER_BOSS_SIZE + 14 }}
    >
      {/* HP bar */}
      <div className="tier-boss-hp-track">
        <div className="tier-boss-hp-fill" style={{ width: `${hpFrac * 100}%` }} />
      </div>

      {/* Directional goblin-king sprite */}
      <GoblinKingSprite dx={dx} dy={dy} size={TIER_BOSS_SIZE} />
    </div>
  );
}
